import React from "react";
import PropTypes from "prop-types";
import ModalEditor from "./ModalEditor";
import Editor from "./Editor";
import Icon from "../../../components/Icon";

const BLOCK_TYPES = [
	{ label: <Icon iconName={"quote"}/>, style: "blockquote" },
	{ label: <Icon iconName={"unorderedList"}/>, style: "unordered-list-item" },
	{ label: <Icon iconName={"orderedList"}/>, style: "ordered-list-item" }
];

const INLINE_STYLES = [
	{ label: <Icon iconName={"bold"}/>, style: "BOLD" },
	{ label: <Icon iconName={"italic"}/>, style: "ITALIC" },
	{ label: <Icon iconName={"underlined"}/>, style: "UNDERLINE" }
];

export default class TextEditor extends React.Component
{
	render()
	{
		const { modal = false, additionalKey = "" } = { ...this.props };
		
		return modal
			? <ModalEditor {...this.props}
			               additionalKey={additionalKey}
			               inlineControlTypes={INLINE_STYLES}
			               blockControlTypes={BLOCK_TYPES}
			               trigger={
				               this.props.trigger
					               ? this.props.trigger
					               : <button className="btn btn-small btn-flat hover-light-grey hover-secondary-color-text">
						               <Icon iconName={"help"}/>
					               </button>
			               }
			/>
			: <Editor {...this.props}
			          additionalKey={additionalKey}
			          inlineControlTypes={INLINE_STYLES}
			          blockControlTypes={BLOCK_TYPES}
			/>;
		
	} // function render()
	
} // class

TextEditor.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	isHidden: PropTypes.bool,
	modal: PropTypes.bool,
	trigger: PropTypes.object,
	additionalKey: PropTypes.string,
	className: PropTypes.string,
	content: PropTypes.string,
	headerTitle: PropTypes.string
};

